import { compareText, matchesQuery, selectedAllows } from './directory-filter';
import { htmlToPlainText } from './rich-text';
import type { ProjectDto } from './work-types';

export const PROJECT_ACCESS = ['member', 'requested', 'not_member'] as const;
export type ProjectAccess = (typeof PROJECT_ACCESS)[number];

export const PROJECT_ACCESS_LABELS: Record<ProjectAccess, string> = {
  member: 'Member',
  requested: 'Requested',
  not_member: 'Not a member',
};

export const PROJECT_SORT_OPTIONS = [
  { value: 'name', label: 'Name A-Z' },
  { value: '-name', label: 'Name Z-A' },
  { value: 'identifier', label: 'Key A-Z' },
  { value: '-identifier', label: 'Key Z-A' },
] as const;

export const PROJECT_DEFAULT_ORDER = 'name';

export function projectAccess(project: ProjectDto): ProjectAccess {
  if (project.requested === true) return 'requested';
  if (project.is_member === false) return 'not_member';
  return 'member';
}

export function projectAccessLabel(value: ProjectAccess): string {
  return PROJECT_ACCESS_LABELS[value];
}

export function filterProjects(
  items: ProjectDto[],
  opts: { query: string | null; access: string[]; orderBy: string | null },
): ProjectDto[] {
  const filtered = items.filter((item) => {
    if (!selectedAllows(opts.access, projectAccess(item))) return false;
    return matchesQuery(opts.query, [item.name, item.identifier, htmlToPlainText(item.description ?? '')]);
  });
  const orderBy = opts.orderBy ?? PROJECT_DEFAULT_ORDER;
  return filtered.slice().sort((left, right) => {
    if (orderBy === '-name') return compareText(right.name, left.name);
    if (orderBy === 'identifier') return compareText(left.identifier, right.identifier);
    if (orderBy === '-identifier') return compareText(right.identifier, left.identifier);
    return compareText(left.name, right.name);
  });
}
